import Image from "next/image";
import { APPROACH, SECTION_IDS } from "./content";
import { Reveal } from "./reveal";

export const Approach = () => (
  <section
    id={SECTION_IDS.approach}
    className="relative overflow-hidden px-[clamp(16px,4vw,64px)] py-[clamp(110px,16vw,240px)]"
  >
    <div className="absolute inset-0 z-0">
      <Image
        src="/images/croptypes1.webp"
        alt=""
        fill
        sizes="100vw"
        className="object-cover opacity-[.7] saturate-[.9] [animation:dc-drift_60s_ease-in-out_infinite]"
      />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,#030C16_0%,rgba(3,12,22,.5)_20%,rgba(3,12,22,.55)_72%,#030C16_100%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(100deg,rgba(3,12,22,.88)_4%,rgba(3,12,22,.3)_52%,rgba(3,12,22,.62)_100%)]" />
    </div>

    <div className="dc-shell relative z-2">
      <h2 className="m-0 max-w-[15ch] text-[clamp(40px,8.4vw,148px)] font-bold leading-[.92] tracking-[-.045em] text-balance">
        You do not need Earth observation.
      </h2>
      <h2 className="mt-[18px] mb-0 max-w-[18ch] text-[clamp(26px,3.6vw,62px)] font-medium leading-[1.02] tracking-[-.03em] text-mint">
        You need the answers it contains.
      </h2>

      {/* From xl the four points sit beside the intro rather than below it. */}
      <div className="mt-[42px] grid items-start gap-x-[clamp(48px,6vw,120px)] gap-y-[clamp(64px,9vw,130px)] xl:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        <p className="m-0 max-w-[56ch] text-[clamp(16px,1.4vw,20px)] leading-[1.7] text-mist-1">
          We built the infrastructure — the archive, the workflows, the models —
          so that you don&apos;t have to. Bring us the question and we return an
          answer that is current, defensible and ready to use.
        </p>

        <div className="grid max-w-[900px] grid-cols-1 gap-x-[clamp(32px,4vw,80px)] gap-y-[clamp(32px,4vw,64px)] md:grid-cols-2 xl:max-w-none">
          {APPROACH.map((item, index) => (
            <Reveal key={item.num} delay={index * 90}>
              <div className="mb-5 flex items-center gap-3">
                <span className="dc-mono text-[12px] tracking-[.18em] text-mint">
                  {item.num}
                </span>
                <span className="h-px flex-1 bg-white/[.22]" />
              </div>
              <h3 className="mt-0 mb-3.5 text-[clamp(20px,1.9vw,27px)] font-semibold leading-[1.15] tracking-[-.02em] text-balance">
                {item.title}
              </h3>
              <p className="m-0 text-[17px] leading-[1.7] text-mist-2">
                {item.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
